import { Message } from "../../../domain/model/Auth";
import { Product } from "../../../domain/model/Product";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { ProductRepository } from "./ProductRepository";

export class ProductRepositoryImpl implements ProductRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  create(product: Product): Promise<Response<Message>> {
    return this.apiService.createProduct(product);
  }
  getAll(): Promise<Response<Array<Product>>> {
    return this.apiService.getProducts();
  }
  get(id: string): Promise<Response<Product>> {
    return this.apiService.getProduct(id);
  }
  update(product: Product): Promise<Response<Message>> {
    return this.apiService.updateProduct(product);
  }
  delete(id: string): Promise<Response<Message>> {
    return this.apiService.deleteProduct(id);
  }
  getDeliveryPrice(): Promise<Response<number>> {
    return this.apiService.getDeliveryPrice();
  }
  editDeliveryPrice(price: number): Promise<Response<Message>> {
    return this.apiService.editDeliveryPrice(price);
  }
}
